import api from './api'

const userService = {}

// Verify Email
userService.verifyEmail = token => api.post(`/users/verify-email/${token}`)

userService.getMetricaPlayLinks = () => api.get('/users/get-metrica-play-links')

export default userService
